import "./header.css";
import { routes } from "../../../routes";
import { useEffect, useState } from "react";
import Payment from "./PaymentModal/Payment";
import Login from "../../../pages/auth/Login";
import Signup from "../../../pages/auth/Signup";
import SearchModal from "../../SearchModal/Search";
import WalletModal from "./walletModal/WalletModal";
import { Menu, Search, X } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, Link } from "react-router-dom";
import HeaderDropdowns from "../../headerDropdowns/HeaderDropdowns";
import { getAccountBalance } from "../../../api/modules/b2droppie.class";
import WebLogo from "../../../assets/images/logo/droppie-web-logo.svg";
import { toggleOnboard } from "../../../redux/slices/onBoardingSlice";
import { icons, profileImages } from "../../../utils/globalImages";
import { ReactComponent as Plus } from "../../../assets/icons/Plus.svg";
import { logout } from "../../../redux/slices/authSlice";
import {
  setAccount,
  togglePayment,
  toggleSearchModal,
} from "../../../redux/slices/accountSlice";
import WithdrawConfirmDialog from "../../WithdrawConfirmDialog/WithdrawConfirmDialog";
import { ReactComponent as ShoppingCart } from "../../../assets/icons/cart.svg";
import { ReactComponent as Dollar } from "../../../assets/icons/dollar.svg";
import { ReactComponent as KYC } from "../../../assets/drawings/KYCBadge.svg";
import ArrowProgressBar from "../../common/ProgressBar/ArrowProgressBar.jsx";
import MobileLogo from "../../../assets/icons/logo.png";

const Header = ({ loading, setLoading }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [pendingItems, setPendingItems] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const paymentDataIs = useSelector((state) => state?.payment);
  const payment = useSelector((state) => state?.account?.payment);
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);
  const searchModal = useSelector((state) => state?.account?.searchModal);
  const user = useSelector((state) => state?.auth?.user);
  const userAccount = useSelector((state) => state?.account);
  const itemsCount = useSelector(
    (state) => state?.auth?.user?.cart_items_count,
  );
  const formattedBalance = useSelector(
    (state) => state?.account?.formatted_balance,
  );

  const navItems = [
    {
      name: "Boxes",
      path: routes.UNBOXES,
      icon: icons.Boxes,
      badge: "",
    },
    {
      name: "Battles",
      icon: icons.Battles,
      path: routes.BATTLES,
    },
    {
      name: "Become Referrer",
      path: routes.BECOMEREFERRER,
      icon: icons.refrrer,
      badge: "",
    },
  ];

  const getbalance = async () => {
    try {
      const response = await getAccountBalance();
      const accountData = response?.data?.data;
      if (accountData) {
        dispatch(
          setAccount({
            balance: parseFloat(accountData.balance) || 0,
            current_xp: accountData.current_xp || 0,
            level: accountData.level || 0,
            next_level_xp: accountData.next_level_xp || 0,
            current_progress: accountData.current_progress || 0,
            next_level: accountData.next_level || 0,
            formatted_balance: accountData.formatted_balance || "0",
          }),
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      getbalance();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen) {
        const mobileMenuContent = document.querySelector(
          ".mobile-menu-content",
        );
        const menuButton = document.querySelector(".mobile-menu-button");
        if (
          mobileMenuContent &&
          !mobileMenuContent.contains(event.target) &&
          menuButton &&
          !menuButton.contains(event.target)
        ) {
          setIsOpen(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, [isOpen]);

  const openWithdrawModal = () => {
    dispatch(togglePayment({ payment: true }));
  };

  const openSearchModal = () => {
    dispatch(toggleSearchModal(true));
  };

  const isActiveRoute = (path) => {
    if (path === routes.HOME) return false;
    return location?.pathname === path;
  };

  const handleLogout = () => {
    setIsOpen(false);
    dispatch(logout());
  };

  return (
    <>
      <nav
        className={`modern-navbar ${isDarkMode ? "dark-mode" : "light-mode"}`}
      >
        <div className="container-fluid px-0 px-lg-3">
          <div className="navbar-content">
            <div className="d-center">
              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="mobile-menu-button"
              >
                {isOpen ? <X /> : <Menu />}
              </button>

              <Link to={routes.HOME} className="d-center logo-section gap-10px">
                <img
                  height={62}
                  width={169}
                  alt="Droppie Logo"
                  className="w-100 logo-desktop"
                  src={WebLogo}
                />
                <img
                  height={36}
                  alt="Droppie Logo"
                  className="w-100 logo-mobile"
                  src={MobileLogo}
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="desktop-nav">
              {navItems.map((item) => {
                const isActive = isActiveRoute(item.path);
                return (
                  <button
                    key={item.name}
                    onClick={() => navigate(item.path)}
                    className={`nav-item ${isActive ? "active" : ""}`}
                  >
                    <div
                      className="nav-item-inner"
                      style={{
                        backgroundColor:
                          location.pathname === item.path
                            ? "#ffcb21"
                            : "#A6A6A6",
                        WebkitMaskImage: `url(${item.icon})`,
                        maskImage: `url(${item.icon})`,
                      }}
                    />
                    <span>{item.name}</span>
                    {item.badge && (
                      <span className="nav-badge">{item.badge}</span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Right Actions */}
            <div className="navbar-actions">
              {/* Balance Display */}
              {isLoggedIn && (
                <div className="balance-display" onClick={openWithdrawModal}>
                  <span className="balance-amount">
                    <Dollar
                      style={{
                        height: "15px",
                        width: "15px",
                        marginBottom: "2px",
                        marginRight: "4px",
                      }}
                    />
                    {formattedBalance ? formattedBalance : "0.00"}
                  </span>
                  <button className="balance-plus">+</button>
                </div>
              )}

              {/* Cart */}
              {isLoggedIn && (
                <button
                  onClick={() => navigate(routes.CART)}
                  className="icon-button search-button"
                >
                  <ShoppingCart />
                  {itemsCount > 0 && (
                    <span className="cart-badge">
                      {itemsCount > 99 ? (
                        <span
                          style={{
                            fontSize: "8px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          99<small>+</small>
                        </span>
                      ) : (
                        itemsCount
                      )}
                    </span>
                  )}
                </button>
              )}

              {/* Search */}
              <button
                onClick={openSearchModal}
                className="icon-button search-button"
              >
                <Search size={18} />
              </button>

              {/* Desktop Dropdown (Avatar) */}
              {isLoggedIn && (
                <HeaderDropdowns
                  loading={loading}
                  isLogged={isLoggedIn}
                  setLoading={setLoading}
                />
              )}

              {/* Desktop Auth */}
              {!isLoggedIn && (
                <div className="desktop-auth">
                  <button
                    onClick={() => dispatch(toggleOnboard({ login: true }))}
                    className="auth-button login-button"
                  >
                    <span>Login</span>
                  </button>
                  <button
                    onClick={() => dispatch(toggleOnboard({ register: true }))}
                    className="auth-button signup-button"
                  >
                    <span>Signup</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Mobile Menu ── */}
        {isOpen && (
          <div className="mobile-menu-wrapper">
            {/* Backdrop overlay */}
            <div
              className="mobile-menu-overlay"
              onClick={() => setIsOpen(false)}
            />

            <div className="profile-dropdown-main mobile-menu-content px-3 pt-4 pb-4">
              {/* Dark tint layer */}
              <div
                style={{
                  inset: 0,
                  opacity: 0.15,
                  position: "absolute",
                  filter: "brightness(0.7)",
                  backgroundColor: "#262626",
                  borderRadius: "24px",
                }}
              />

              <div
                className="container"
                style={{ position: "relative", zIndex: 1, padding: "0px 8px" }}
              >
                {/* ── User Header ── */}
                {isLoggedIn && user && (
                  <div className="row mb-2">
                    <div className="col-8">
                      <div className="row align-items-center flex-nowrap">
                        {/* Avatar */}
                        <div
                          className="col-3 p-0"
                          style={{
                            flex: "0 0 auto",
                            width: "auto",
                            paddingRight: "12px",
                          }}
                        >
                          <img
                            alt="User Avatar"
                            src={
                              user?.userdetails?.avatar
                                ? user?.userdetails?.avatar
                                : profileImages.userAvatarReplacement
                            }
                            className="profile-avatar"
                          />
                        </div>
                        {/* Username & Email */}
                        <div
                          className="col-9 ps-2"
                          style={{ flex: 1, width: "auto", maxWidth: "none" }}
                        >
                          <p
                            className="header-title d-start gap-10px mb-1"
                            style={{
                              color: "#fff",
                              fontSize: "18px",
                              fontWeight: 700,
                            }}
                          >
                            {user?.userdetails?.username}
                            {user?.kyc && (
                              <KYC className="kyc-icon" width={50} />
                            )}
                          </p>
                          <p className="header-subtitle">{user?.email}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* ── XP / Level Progress ── */}
                {isLoggedIn && (
                  <div className="row user-xp-outer mt-3">
                    <ArrowProgressBar user={userAccount} isProfile={true} />
                  </div>
                )}

                {/* ── Nav Items ── */}
                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  {/* Dynamic items: Boxes, Battles, Become Referrer */}
                  {navItems.map((item) => {
                    const isActive = isActiveRoute(item.path);
                    return (
                      <div
                        key={item.name}
                        className={`row cursor-pointer profile-outer ${isActive ? "active" : ""}`}
                        onClick={() => {
                          navigate(item.path);
                          setIsOpen(false);
                        }}
                      >
                        <div className="col-8 d-start text-light-gray">
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              backgroundColor: isActive ? "#FFCB21" : "#A6A6A6",
                              WebkitMaskImage: `url(${item.icon})`,
                              maskImage: `url(${item.icon})`,
                              WebkitMaskRepeat: "no-repeat",
                              maskRepeat: "no-repeat",
                              WebkitMaskSize: "contain",
                              maskSize: "contain",
                              flexShrink: 0,
                            }}
                          />
                          <span className="m-icon-left">{item.name}</span>
                        </div>
                        {item.badge && (
                          <div className="col-4 d-flex justify-content-end align-items-center pe-3">
                            <span className="mobile-nav-badge">
                              {item.badge}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* Profile */}
                  {isLoggedIn && (
                    <div
                      className="row cursor-pointer profile-outer"
                      onClick={() => {
                        setIsOpen(false);
                        navigate(routes.ACCOUNT);
                      }}
                    >
                      <div className="col-6 d-start">
                        <i
                          aria-hidden="true"
                          className="fa fa-user text-light-gray text-19x"
                        />
                        <span className="text-light-gray m-icon-left">
                          Profile
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Cart */}
                  {isLoggedIn && (
                    <div
                      className="row cursor-pointer cart-outer"
                      onClick={() => {
                        setIsOpen(false);
                        navigate(`${routes.ACCOUNT}${routes.ACCOUNT_CART}`);
                      }}
                    >
                      <div className="col-6 d-start text-light-gray">
                        <ShoppingCart width={20} height={20} />
                        <span className="m-icon-left">Cart</span>
                      </div>
                    </div>
                  )}

                  {/* Logout */}
                  {isLoggedIn && (
                    <div
                      className="row cursor-pointer logout-outer"
                      onClick={handleLogout}
                    >
                      <div className="col-6 d-start text-light-gray">
                        <img src={profileImages.logout} alt="Logout" />
                        <span className="m-icon-left">Logout</span>
                      </div>
                    </div>
                  )}

                  {/* Guest: Login / Signup */}
                  {!isLoggedIn && (
                    <>
                      <div
                        className="row cursor-pointer profile-outer"
                        onClick={() => {
                          setIsOpen(false);
                          dispatch(toggleOnboard({ login: true }));
                        }}
                      >
                        <div className="col-6 d-start">
                          <i
                            aria-hidden="true"
                            className="fa fa-sign-in text-light-gray text-19x"
                          />
                          <span className="text-light-gray m-icon-left">
                            Login
                          </span>
                        </div>
                      </div>
                      <div
                        className="row cursor-pointer cart-outer"
                        onClick={() => {
                          setIsOpen(false);
                          dispatch(toggleOnboard({ register: true }));
                        }}
                      >
                        <div className="col-6 d-start text-light-gray">
                          <i
                            aria-hidden="true"
                            className="fa fa-user-plus text-19x"
                          />
                          <span className="m-icon-left">Signup</span>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Modals */}
      <Login />
      <Signup />
      <SearchModal
        show={searchModal}
        onHide={() => dispatch(toggleSearchModal(false))}
      />
      {paymentDataIs && <Payment paymentData={paymentDataIs?.data} />}
      <WalletModal
        show={payment}
        pendingItems={pendingItems}
        setConfirmOpen={setConfirmOpen}
        onHide={() => dispatch(togglePayment())}
      />
      <WithdrawConfirmDialog
        open={confirmOpen}
        isDarkMode={isDarkMode}
        onCancel={() => {
          setConfirmOpen(false);
          setPendingItems([]);
        }}
      />
    </>
  );
};

export default Header;
